import * as React from "react";
import {cx} from "emotion";

import "./user-created-folder-modal.scss";

import {bindInput}         from "@Common/react/bind-input";
import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {keyed}             from "@Common/react/keyed";
import {Load}              from "@Common/react/load";
import {Load2}             from "@Common/react/load2";
import {scopedState}       from "@Common/react/scoped-state";
import {UseState}          from "@Common/react/use-state";
import {ModalService3}     from "@Common/ui-components/modal-service-3/modal-service-3";
import {Responsive}        from "@Common/ui-components/responsive";
import {AgentMultiSelect}  from "@Common/ui-components/searchable-multi-select/agent-multi-select";
import {OfficeMultiSelect} from "@Common/ui-components/searchable-multi-select/office-multi-select";
import {SliderCheckbox}    from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {ModalLayout}       from "../../../common/modal-layout/modal-layout";

export const UserCreatedFolderModal = ({activeTab, folderId, index, folders, next: rootNext}) => cs(
    consumeContext("routerHistory"),
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
        },
        next,
    }}/>],
    ["modal", ({responsive, routerHistory}, next) => <>
        {folderId || folderId===0 ? (
            <ModalService3 {...{
                xdQaName: "User Created Folder Modal",
                width: responsive.lt("mobile") ? 360 : "fit-content",
                xToClose: false,
                onPassiveClose: async () => {
                    return false;
                },
                onClose: async () => {
                    routerHistory.replace(`/manage-templates/${activeTab}`)
                },
                next,
                rootNext,
            }}/>
        ) : (
            rootNext()
        )}
    </>],
    consumeContext("apis"),
    consumeContext("catSubStyle"),
    ["folder", ({apis}, next) => Load2({
        fetch: () => folderId ? apis.next.userCreated.getFolder(folderId): {idPrimary: 0, shareAll: true, isPrivate: activeTab == "private"},
        next,
    })],
    ["uploading", (_, next) => UseState({next})],
    ["branchList", ({apis}, next) => Load({
        fetch: () => apis.next.getBranchList({filterByUserLevel: false}),
        next,
    })],
    ["selectedBranches", ({branchList, folder}, next) => UseState({
        _key: branchList && folder.loading,
        getInitValue: ()=>{
            const branchInclusions = folder.value?.inclusions ? (JSON.parse( folder.value?.inclusions )['branches'] ?? []): [];
            return branchList?.filter((branch)=> branchInclusions.includes(branch.idBranch)) ?? [];
        },
        next,
    })],
    ["agentList", ({apis}, next) => Load({
        fetch: () => apis.next.getAgentList("", 0, 0),
        next,
    })],
    ["selectedAgents", ({agentList, folder}, next) => UseState({
        _key: agentList && folder.loading,
        getInitValue: ()=>{
            const agentInclusions = folder.value?.inclusions ? (JSON.parse( folder.value?.inclusions )['agents'] ?? []): [];
            return agentList?.filter((agent)=> agentInclusions.includes(agent.idAgent)) ?? [];
        },
        next,
    })],
    ({apis, catSubStyle, modal, folder, selectedAgents, selectedBranches, uploading}, next) => ModalLayout({
        title: "Folder Information",
        content: next(),
        buttons: [
            {
                label: "Cancel",
                onClick: () => {
                    modal.close();
                },
            },
            {
                label: "Save",
                disabled: uploading.value || !folder.value?.name,
                primary: true,
                onClick: async () => {
                    uploading.onChange(true);
                    let updateFields = {
                        idPrimary: folder.value.idPrimary,
                        isPrivate: folder.value.isPrivate,
                        name: folder.value.name,
                        shareAll: folder.value.shareAll,
                    }
                    let sequence = folders.value.length;
                    if( !folder.value.idPrimary ) {
                        if(folders.value[sequence-1].sequence >= sequence){
                            sequence = folders.value[sequence-1].sequence + 1;
                        }
                        updateFields['sequence'] = sequence;
                    }
                    if(!folder.value.shareAll){
                        let inclusions = {};
                        if(selectedBranches.value.length){
                            inclusions['branches']= selectedBranches.value.map((branch)=>branch.idBranch);
                        }
                        if(selectedAgents.value.length){
                            inclusions['agents']= selectedAgents.value.map((agent)=>agent.idAgent);
                        }
                        updateFields['inclusions'] = JSON.stringify(inclusions);
                    }
                    const result = await apis.next.userCreated.updateFolder({updateFields});
                    if( result?.errors || result?.errorMessage ) {
                        alert("An error has occurred.");
                    } else {
                        let obj = folders.value;
                        if( (activeTab == 'private' && !folder.value.isPrivate) || (activeTab == 'public' && folder.value.isPrivate) ) {
                            if(index) {
                                delete obj[index];
                            }
                        }
                        else {
                            if(index) {
                                obj[index] = {...folder.value, idPrimary: result.idPrimary};
                            }
                            else {
                                obj.push({...folder.value, idPrimary: result.idPrimary, sequence});
                            }
                        }
                        folders.onChange(obj);
                        await catSubStyle?.reload();
                        modal.close();
                    }
                    uploading.onChange(false);
                },
            },
        ],
    }),
    ({agentList, branchList, folder, selectedAgents, selectedBranches}) => (folder.loading ? (
            <div className="user-created-folder-modal-s7c">
                <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                    Loading...
                </div>
            </div>
        ) : (
            <div className="user-created-folder-modal-s7c">
                <div className="input-card">
                    <div className="label">Folder Name <span style={{color: "red"}}> *</span></div>
                    <input {...{
                        className: "value",
                        maxLength: 64,
                        "xd-qa-type": "textbox",
                        "xd-qa-name": "Enter a Folder Name",
                        ...bindInput(scopedState(folder, ["name"]))
                    }}/>
                    <div className="label">Share With</div>
                    <div className="methods">
                        <div
                            className={cx("method", (scopedState(folder, ['shareAll']).value ? "selected" : ""))}
                            key="everyone"
                            onClick={() => scopedState(folder, ["shareAll"]).onChange(1)}
                            xd-qa-type="button"
                            xd-qa-name="everyone"
                        >
                            <div className="label">
                                Everyone
                            </div>

                            {scopedState(folder, ['shareAll']).value ?
                                <div className="check">
                                    <i className="fa fa-check-circle"/>
                                </div> : ""
                            }
                        </div>
                        <div
                            className={cx("method", !scopedState(folder, ['shareAll']).value ? "selected" : "")}
                            key={'selected'}
                            onClick={() => scopedState(folder, ["shareAll"]).onChange(0)}
                            xd-qa-type="button"
                            xd-qa-name="selected"
                        >
                            <div className="label">
                                Only Selected Users
                            </div>

                            {!scopedState(folder, ['shareAll']).value ?
                                <div className="check">
                                    <i className="fa fa-check-circle"/>
                                </div> : ""
                            }
                        </div>
                    </div>
                    {!scopedState(folder, ['shareAll']).value ? <>
                        <div className="label">Add Users</div>
                        <div className="dropdown">
                            {OfficeMultiSelect({branchList, displayList:true, selectedBranches})}
                        </div>
                        <div>
                            {AgentMultiSelect({agentList, branchList, displayList:true, selectedAgents})}
                        </div>
                    </> : <></>}
                    <div className="check-line">
                        <div>Private</div>
                        {SliderCheckbox({
                            ...scopedState(folder, ['isPrivate']),
                            xdQaName: "Private",
                        })}
                    </div>
                </div>
            </div>
        )
    )
);
